import React, { useState, useEffect } from "react";
import { Label } from "reactstrap";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import {BACKEND_URL_LOG, BACKEND_URL_PORTAIL} from "../../config/const.js";
import { withTranslation } from "react-i18next";
//import images
import logoSm from "../../assets/images/QUESS.ENG.Couleur.png";
import logoFrDark from "../../assets/images/quess_360_solutions-pharmacies.png";
import logoDark from "../../assets/images/quess_360_solutions-pharmacies.png";
import { isEmpty } from 'lodash';
import MultiSelect from './MultiSelect.js';
import MultiSelectCleanroom from './MultiSelectCleanroom.js'
// import logoLight from "../../assets/images/logo-light.png";
// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions.js";
import { useTranslation } from "react-i18next";
import { initSessionManager, clearSessionManually } from '../../helpers/sessionManager';
import { verifySession } from '../../helpers/sessionValidation';


const Header = (props) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();
  const lang = localStorage.getItem("lang");
  const [clientId, setClientId] = useState(null);
 
  const defaultRole = {
    id: '0',
    value: t('noRoles'),
    label: t('noRoles')
  };
  const defaultCleanRoom = {
    id: '0',
    value: t('withOutCleanroom'),
    label: t('withOutCleanroom')
  };
  const [organisations, setOrganisations] = useState([]);
  const [selectedGroupe, setSelectedGroupe] = useState('');
  const [roles, setRoles] = useState([]);
  const [cleanRooms, setCleanRooms] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsCleanroom, setSelectedOptionsCleanroom] = useState([]);
  const [allRoles, setAllRoles] = useState([]);
  const [allCleanroom, setAllCleanroom] = useState([]);
  
  const [rolesIds] = useState([]);
  const [cleanroomIds] = useState([]);
  const [typeInstalsOrgs, setTypeInstalsOrgs] = useState([]);
  const [typeInstalOrg, setTypeInstalOrg] = useState("all");
  
  
  const navigate = useNavigate();

  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
 useEffect(() => {
    // La validite de la session est desormais controlee par AuthProtected
    // AVANT le rendu de ce layout : on reutilise ici le resultat partage
    // (aucun appel reseau supplementaire au chargement). Cet effet ne sert
    // plus que de filet de securite si le token expire pendant la navigation.
    verifySession().then((isValid) => {
      if (!isValid) {
        localStorage.clear();
        window.location.href = "/login";
      }
    });
  }, []);
  // Fetch User Profile
  useEffect(() => {
    //initSessionManager();
    checkAvailableUser();
    const fetchUserProfile = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL_LOG}connectedUserInfo`, config);
        localStorage.setItem("user", JSON.stringify(response));
        
        setLoading(false);
      } catch (error) {
        setLoading(false);
        if (error === "Request failed with status code 401") {
          localStorage.clear();
          navigate("/login", { replace: true });
        } else {
          setError("Failed to load profile data");
          console.error(error);
        }
      }
    };
    fetchUserProfile();
    getUserOrganisations();
  }, []);

  const checkAvailableUser = () => {
  const config = {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  };
  axios.get(BACKEND_URL_PORTAIL + 'api/checkAvailableUser', config)
    .then(response => {
      if (response.available === false) {
        localStorage.clear();
        window.location.href = '/login';
      }
    })
    .catch(error => {
      console.error("Erreur API checkAvailableUser :", error);
      localStorage.clear();
      window.location.href = '/login';
    });
  };

  // Retrieve client from localStorage
  useEffect(() => {
    const client = localStorage.getItem("currentOrg");
    if (client) {
      setClientId(client);
    }
  }, [localStorage.getItem("currentOrg")]);

  

  // Handle Group Selection
  function handleSelectGroup(selectedOption) {
    localStorage.setItem("currentOrg", selectedOption.value);
    setSelectedGroupe(selectedOption);
    setClientId(selectedOption.value);
    localStorage.removeItem('roles');
    localStorage.removeItem('cleanroom');
    getOrganisationRoles(selectedOption.value);
    getOrganisationCleanroom(selectedOption.value)
    getTypeIntallByOrg(selectedOption.value);
    window.location = '/home';
  }
  function handleSelectInstalOrg (selectedOption){
    localStorage.setItem('type', selectedOption.Sanstraduction);
    setTypeInstalOrg(selectedOption);
    window.location = '/home';
    
  }

  // Sidebar Toggle Function
/*   function tToggle() {
    const body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  } */
   function tToggle() {
  const body = document.body;
  const width = window.innerWidth; // plus fiable sur iPad

  if (width <= 998) {
    body.classList.toggle("sidebar-enable");
  } else {
    body.classList.toggle("vertical-collpsed");
    body.classList.toggle("sidebar-enable");
  }
}


  // Language Change Function
  const changeLanguage = () => {
    const currentLang = localStorage.getItem("lang");
    const newLang = currentLang === "en" ? "fr" : "en";
    localStorage.setItem("lang", newLang);
    window.location.reload();
  };

  // Logout Function
  const handleLogout = () => {
    navigate("/logout");
  };
  const getUserOrganisations = () => {
    const config = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    };
 
    axios.get(BACKEND_URL_PORTAIL + 'api/connectedUserOrganisations', config)
      .then(response => {
          const orgOptions = response.map((org) => ({
            label: org.name,
            value: org.id,
          }));
        setOrganisations(orgOptions);

        if (!isEmpty(localStorage.getItem('currentOrg'))) {
          const selectedOrg = orgOptions.find((org) => org.value == parseInt(localStorage.getItem('currentOrg')));
          setSelectedGroupe(selectedOrg || orgOptions[0]);
          getOrganisationRoles(localStorage.getItem('currentOrg'));
          getOrganisationCleanroom(localStorage.getItem('currentOrg'));
          getTypeIntallByOrg(localStorage.getItem('currentOrg'));
        } else {

          localStorage.setItem('currentOrg', response[0].id);
          setSelectedGroupe(orgOptions[0]);
          getOrganisationRoles(response[0].id);
          getOrganisationCleanroom(response[0].id);
          getTypeIntallByOrg(response[0].id);
        }
      
      }).catch(error => console.error(error));
  };
  const getOrganisationCleanroom = (idOrganisation) => {
    const config = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    };
    const localCleanroom=[];
    axios.get(BACKEND_URL_LOG + 'getAllClientCleanRooms/' + idOrganisation, config)
      .then(response => {
        localStorage.setItem('allCleanrooms', JSON.stringify(response.cleanRooms));
        response.cleanRooms.map((el) => {
          localCleanroom.push({
            id:el.id,
            value:el.name,
            label:el.name
          });
          allCleanroom.push(el.id);
        });
        allCleanroom.push('0');
        localStorage.setItem('allCleanroom', JSON.stringify(allCleanroom));
        const cleanroomResults = response.cleanRooms.map(el => ({
          id: el.id,
          value: el.name,
          label: el.name
        }));
        if (!isEmpty(response.cleanRooms)) {
          localCleanroom.push(defaultCleanRoom);
          cleanroomResults.push(defaultCleanRoom);
        }
        
        if (!isEmpty(localStorage.getItem('cleanroom'))) {
          localStorage.setItem('cleanroom', localStorage.getItem('cleanroom'));
          const myArray = JSON.parse(localStorage.getItem('cleanroom'));
          const thirdArray = cleanroomResults.filter((elem) => {
            if (elem.label === t('withOutCleanroom')) {
            // Remplacer l'élément avec le label "No Roles" par un autre texte
              elem.label = t('withOutCleanroom');
              elem.value = t('withOutCleanroom');
            // Vous pouvez également modifier d'autres propriétés de l'élément ici
            }
            return myArray.some((ele) => ele === elem.id);
          });
          setSelectedOptionsCleanroom(thirdArray);
        }else{
          console.log("no set item role ***************")
        }
        setCleanRooms(localCleanroom);
      }).catch(error => console.error(error));
  }
  
  const getOrganisationRoles = (idOrganisation) => {
    const config = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    };
    const localRoles=[];
    axios.get(BACKEND_URL_LOG + 'getAllTeamsbyOrganisationId/' + idOrganisation, config)
      .then(response => {
        response.map((el) => {
          localRoles.push(el);
          allRoles.push(el.id);
        });
        allRoles.push('0');
        localStorage.setItem('allRoles', JSON.stringify(allRoles));
        const rolesResults = response;
        if (!isEmpty(response)) {
          localRoles.push(defaultRole);
          rolesResults.push(defaultRole);
        }
        if (!isEmpty(localStorage.getItem('roles'))) {
          localStorage.setItem('roles', localStorage.getItem('roles'));
          const myArray = JSON.parse(localStorage.getItem('roles'));
          const thirdArray = rolesResults.filter((elem) => {
            if (elem.label === t('noRoles')) {
            // Remplacer l'élément avec le label "No Roles" par un autre texte
              elem.label = t('noRoles');
              elem.value = t('noRoles');
            // Vous pouvez également modifier d'autres propriétés de l'élément ici
            }
            return myArray.some((ele) => ele === elem.id);
          });
          setSelectedOptions(thirdArray);
        }else{
          console.log("no set item role ***************")
        }
        setRoles(localRoles)
      }).catch(error => console.error(error));
  };
  const getTypeIntallByOrg = (idOrg) => {
    axios
    .get(BACKEND_URL_LOG + "getTypeInstallByIdOrganisation/" + idOrg, config)
    .then((response) => {
      // Filtrer les types d'installation où hasRegistres = 1
      const filteredTypeInstalOrgs = response.filter(
        (typeInstallOrg) => typeInstallOrg.hasRegistres === 1
      );

      // Mapper les éléments filtrés en options
      const TypeInstalOrgOptions = filteredTypeInstalOrgs.map((typeInstallOrg) => ({
        label: t(typeInstallOrg.typeKey),
        Sanstraduction: typeInstallOrg.typeKey,
        value: typeInstallOrg.id,
      }));
  
        // Ajouter l'option "all" au début du tableau
        const allOption = {
          label: t("All"), // Traduisez "All" si nécessaire
          Sanstraduction: "all",
          value: 0,
        };
        const optionsWithAll = [allOption, ...TypeInstalOrgOptions];
  
        setTypeInstalsOrgs(optionsWithAll);
  
        const savedType = localStorage.getItem("type") ;
        
        if (savedType==null) {
          
          localStorage.setItem("type", allOption.Sanstraduction);
          setTypeInstalOrg(allOption);
        } else {
          // Trouver l'élément dans optionsWithAll correspondant à savedType
          const matchedOption = optionsWithAll.find(
            (option) => option.Sanstraduction === savedType
          );
  
          if (matchedOption) {
            setTypeInstalOrg(matchedOption);
          } else {
            // Si aucune correspondance n'est trouvée, on peut choisir de réinitialiser à "all"
            setTypeInstalOrg(allOption);
          }
        }
  
        localStorage.setItem("types", JSON.stringify(optionsWithAll));
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des types d'installation :", error);
      });
  };
  
 
  const handleCloseSelect = () => {
    selectedOptions.forEach(element => {
      rolesIds.push(element.id);
    });
  localStorage.setItem('roles', JSON.stringify(rolesIds));
  
    //window.location = '/dashboard';
  };
  const handleCloseSelectCleanroom = () => {
    selectedOptionsCleanroom.forEach(element => {
      cleanroomIds.push(element.id);
    });
   localStorage.setItem('cleanroom', JSON.stringify(cleanroomIds));
  
   // window.location = '/dashboard';
  };
  
  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box text-center">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={lang === "fr" ? logoFrDark : logoSm} alt="logo-sm-dark" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={lang === "fr" ? logoFrDark : logoSm} alt="logo-dark" height="57" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={lang === "fr" ? logoFrDark : logoSm} alt="logo-sm-light" height="22"/>
                </span>
                <span className="logo-lg">
                  <img src={lang === "fr" ? logoFrDark : logoSm} alt="logo-light"  height="57"/>
                </span>
              </Link>
            </div>

            <button  type="button"  className="btn btn-sm px-3 font-size-24 header-item waves-effect"  id="vertical-menu-btn" style={{width:"10%"}}  onClick={tToggle}  >
              <i className="ri-menu-2-line align-middle"></i>
            </button>

           {/*  <span className="logo-lg">
              {logoOrganization ? (
                <img src={`${BACKEND_URL}${logoOrganization}`} alt={nameOrganization} height="65" className="logo-org" />
              ) : (
                <h4 style={{ color: "white", marginTop: 22 }}>{nameOrganization ? nameOrganization : "Logo Organization"}</h4>
              )}
            </span> */}
          </div>
            <div className="divHeader">
            <div className="select-container-header" >
              <div>
              
                <form className="app-search">
                  <label style={{color: "white",justifyContent: "center",display: "flex",alignItems: "center"}}>{t("organisation")}:</label>
                  {loading ? (
                    <p>Loading organizations...</p>
                  ) : error ? (
                    <p>{error}</p>
                  ) : (
                    <Select value={selectedGroupe} menuPosition="fixed" className="custom-select" onChange={handleSelectGroup}  options={organisations} 
                    classNamePrefix="select2-selection"  placeholder={t("selectOrg")}   />
                  )}
                </form>    
              </div>          
            <div>
              
              <form className="app-search">
                  <label style={{color: "white",justifyContent: "center",display: "flex",alignItems: "center"}}>{t("Type")}:</label>
                  {loading ? (
                    <p>Loading types...</p>
                  ) : error ? (
                    <p>{error}</p>
                  ) : (
                    <Select value={typeInstalOrg} menuPosition="fixed" className="custom-select" onChange={handleSelectInstalOrg}   options={typeInstalsOrgs} 
                    classNamePrefix="select2-selection"  placeholder={t("selectTypeInstalOrg")}   />
                  )}
              </form>
              
            </div>
              <div>   
                  <label style={{color: "white" ,justifyContent: "center",display: "flex",alignItems: "center"}}>{t("roles")}:</label>
                
                  { (() => {
                      if (roles.length > 1) {
                        return (
                          <>
                              <MultiSelect  options={roles} menuPosition="fixed"  disabled={false} setSelectedRoles={setSelectedOptions} handleCloseSelect={handleCloseSelect}   /* style={localStorage.getItem('theme')==="dark"?{color:"black"}:{}} */
                                IconComponent={(props) => (
                                  <i className="bi bi-caret-down-fill" {...props} style={{ color: 'black' }} /> 
                                )}/>
                          
                          </>
                        );
                      }

                      return (
                        <>
                        <MultiSelect options={[]}  disabled={true} setSelectedRoles={setSelectedOptions} handleCloseSelect={handleCloseSelect}   /* style={localStorage.getItem('theme')==="dark"?{color:"black"}:{}} */
                                IconComponent={(props) => (
                                  <i className="bi bi-caret-down-fill" {...props} style={{ color: 'black' }} />
                                )}/>
                        </>
                      );
                    })()}
              </div>   
              <div>    
                  <label style={{color: "white",justifyContent: "center",display: "flex",alignItems: "center" }}>{t("cleanroom")}:</label> 
                  { (() => {
                      if (cleanRooms.length > 1) {
                        return (
                          <>
                              <MultiSelectCleanroom  options={cleanRooms}   disabled={false} setSelectedCleanroom={setSelectedOptionsCleanroom} handleCloseSelectCleanroom={handleCloseSelectCleanroom}   /* style={localStorage.getItem('theme')==="dark"?{color:"black"}:{}} */
                                IconComponent={(props) => (
                                  <i className="bi bi-caret-down-fill" {...props} style={{ color: 'black' }} /> 
                                )}/>
                          </>
                        
                        );
                      }
                  return (
                    <>
                    <MultiSelectCleanroom options={[]} disabled={true} setSelectedCleanroom={setSelectedOptionsCleanroom} handleCloseSelectCleanroom={handleCloseSelectCleanroom}   /* style={localStorage.getItem('theme')==="dark"?{color:"black"}:{}} */
                            IconComponent={(props) => (
                              <i className="bi bi-caret-down-fill" {...props} style={{ color: 'black' }} />
                            )}/>
                      </>
                    );
                  })()}
            </div>      
            
             
            </div>
            </div>
             
            <div className="d-flex align-items-center" >
            <div className="dropdown  d-lg-inline-block ms-1" >
              <button type="button" className="btn header-item noti-icon" data-toggle="translate" onClick={changeLanguage}>
                <i className="bx bx-globe" />
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <p style={{ color: "white", textDecoration: lang === "en" ? "underline" : "none" }}>EN</p> /
                  <p style={{ color: "white", textDecoration: lang === "fr" ? "underline" : "none" }}>FR</p>
                </div>
              </button>
            </div>

            <button type="button"  onClick={handleLogout}   className="btn header-item noti-icon right-bar-toggle waves-effect"   >
              <i className="dripicons-enter"></i>
            </button>  
            </div>          
          </div>
      </header>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  return { ...state.Layout };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
